/**
 * Step One-style Bundle Builder
 * - 4 quantity blocks (Single, 4 Pack, 7 Pack, 15 Pack) set required bundle size.
 * - SELECT SIZE → Single/Mixed tabs → progress X/Y → slots → Add to Cart.
 */
(function () {
  function formatMoney(cents, format) {
    if (cents == null || cents === '') return '';
    if (typeof cents === 'string') cents = String(cents).replace('.', '');
    var num = Number(cents);
    if (isNaN(num)) return '';
    var value = (num / 100).toFixed(2);
    var valueNoDec = String(Math.round(num / 100));
    var formatStr = (format && typeof format === 'string') ? format : '{{amount}}';
    return formatStr
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, valueNoDec);
  }

  function getSectionsToRender() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }

  function renderCartContents(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    getSectionsToRender().forEach(function (s) {
      var dest = document.getElementById(s.id);
      if (!dest) return;
      var html = parsedState.sections[s.section];
      if (typeof html !== 'string') return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector(s.selector) || doc.body;
        var target = dest.querySelector(s.selector) || dest;
        if (source && target) target.innerHTML = source.innerHTML;
      } catch (e) { return; }
      if (s.id === 'Cart-Drawer' && typeof dest.notesToggle === 'function') dest.notesToggle();
      if (s.id === 'Cart-Drawer' && typeof dest.removeProductEvent === 'function') dest.removeProductEvent();
    });
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      drawer.classList.add('active');
      document.body.classList.add('open-cart');
      document.body.classList.add('open-cc');
    }
    if (typeof window.dispatchCustomEvent === 'function') {
      window.dispatchCustomEvent('cart-drawer:open');
    }
  }

  function getVariantsJson(container) {
    var script = container ? container.querySelector('[data-bundle-variants]') : null;
    if (!script || !script.textContent) script = document.querySelector('[data-bundle-variants]');
    if (!script || !script.textContent) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) { return null; }
  }

  function getOptionsJson(container) {
    var script = container ? container.querySelector('[data-bundle-options]') : null;
    if (!script || !script.textContent) script = document.querySelector('[data-bundle-options]');
    if (!script || !script.textContent) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) { return []; }
  }

  function findVariantByOptions(variants, optionsMap) {
    if (!variants || !variants.length) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var key in optionsMap) {
        if (optionsMap[key] != null && v[key] !== optionsMap[key]) {
          match = false;
          break;
        }
      }
      if (match && v.available) return v;
    }
    return null;
  }

  function findCurrentVariant(container, sectionId) {
    var variants = getVariantsJson(container);
    if (!variants || !variants.length) return null;
    var variantSelects = document.querySelector('#variant-selects-' + sectionId);
    if (variantSelects && typeof variantSelects.currentVariant !== 'undefined' && variantSelects.currentVariant) {
      return variantSelects.currentVariant;
    }
    var productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      var idInput = productForm.querySelector('input[name="id"]');
      if (idInput && idInput.value) {
        var found = variants.find(function (v) { return String(v.id) === String(idInput.value); });
        if (found) return found;
      }
    }
    if (window.location.search.indexOf('variant=') !== -1) {
      var match = window.location.search.match(/variant=(\d+)/);
      if (match) {
        var v = variants.find(function (x) { return String(x.id) === match[1]; });
        if (v) return v;
      }
    }
    return variants[0];
  }

  function updateTierBlockPrices(variantPriceCents) {
    var wrapper = document.querySelector('[data-bundle-quantity-blocks]');
    if (!wrapper || variantPriceCents == null) return;
    var moneyFormat = wrapper.getAttribute('data-money-format') || '{{amount}}';
    var pct1 = parseInt(wrapper.getAttribute('data-tier-1-pct'), 10) || 0;
    var pct3 = parseInt(wrapper.getAttribute('data-tier-3-pct'), 10) || 0;
    var pct6 = parseInt(wrapper.getAttribute('data-tier-6-pct'), 10) || 0;
    var pct9 = parseInt(wrapper.getAttribute('data-tier-9-pct'), 10) || 0;
    var blocks = wrapper.querySelectorAll('[data-quantity-block]');
    blocks.forEach(function (btn) {
      var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
      var perPairCents = variantPriceCents;
      if (qty >= 15) perPairCents = Math.round(variantPriceCents * (100 - pct9) / 100);
      else if (qty >= 7) perPairCents = Math.round(variantPriceCents * (100 - pct6) / 100);
      else if (qty >= 4) perPairCents = Math.round(variantPriceCents * (100 - pct3) / 100);
      else perPairCents = Math.round(variantPriceCents * (100 - pct1) / 100);
      var priceEl = btn.querySelector('[data-block-price]');
      if (priceEl) priceEl.textContent = formatMoney(perPairCents, moneyFormat) + '/pair';
      btn.setAttribute('data-price-cents', perPairCents);
    });
  }

  function initQuantityBlocks() {
    var wrapper = document.querySelector('[data-bundle-quantity-blocks]');
    if (!wrapper) return;
    var blocks = wrapper.querySelectorAll('[data-quantity-block]');
    var sectionId = wrapper.getAttribute('data-section-id');
    blocks.forEach(function (btn) {
      btn.addEventListener('click', function () {
        blocks.forEach(function (b) {
          b.classList.remove('selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('selected');
        btn.setAttribute('aria-pressed', 'true');
        var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        document.documentElement.dispatchEvent(new CustomEvent('bundle:quantity-selected', { detail: { qty: qty, sectionId: sectionId } }));
      });
    });
    var firstBlock = blocks[0];
    if (firstBlock) {
      firstBlock.classList.add('selected');
      firstBlock.setAttribute('aria-pressed', 'true');
      var qty = parseInt(firstBlock.getAttribute('data-qty'), 10) || 1;
      document.documentElement.dispatchEvent(new CustomEvent('bundle:quantity-selected', { detail: { qty: qty, sectionId: sectionId } }));
    }
  }

  function initBundleBuilder(container) {
    if (!container || !container.dataset) return;
    var sectionId = container.dataset.sectionId;
    if (sectionId == null || sectionId === '') return;

    var moneyFormat = container.dataset.moneyFormat != null && container.dataset.moneyFormat !== '' ? container.dataset.moneyFormat : '{{amount}}';
    var maxSlots = parseInt(container.dataset.maxSlots, 10) || 15;
    var variants = getVariantsJson(container);
    var options = getOptionsJson(container);

    var selectSizeMsg = container.querySelector('[data-select-size-msg]');
    var sizeButtons = container.querySelectorAll('[data-size-value]');
    var styleDropdown = container.querySelector('[data-bundle-style-dropdown]');
    var variantCarousel = container.querySelector('[data-bundle-variant-carousel]');
    var slotsWrap = container.querySelector('[data-bundle-slots-wrap]');
    var modeTabs = container.querySelector('[data-bundle-mode-tabs]');
    var progressBar = container.querySelector('[data-bundle-progress-bar]');
    var progressCount = container.querySelector('[data-bundle-progress-count]');
    var qtyValueEl = container.querySelector('[data-bundle-qty-value]');
    var qtyMinusBtn = container.querySelector('[data-qty-minus]');
    var qtyPlusBtn = container.querySelector('[data-qty-plus]');
    var selectedStyleValue = null;
    var sizeOptIndex = parseInt(container.dataset.sizeOptionIndex, 10) || 0;
    var styleOptIndex = parseInt(container.dataset.styleOptionIndex, 10) || 0;
    var atcBtn = container.querySelector('[data-bundle-atc]');
    var focusSizeBtn = container.querySelector('[data-focus-size]');
    var slotMessage = container.querySelector('[data-bundle-slot-message]');
    var slotElements = container.querySelectorAll('[data-slot]');
    var tier3Pct = parseInt(container.dataset.tier3Pct, 10) || 0;
    var tier6Pct = parseInt(container.dataset.tier6Pct, 10) || 0;
    var tier9Pct = parseInt(container.dataset.tier9Pct, 10) || 0;

    var bundleItems = [];
    var currentVariant = null;
    var selectedQuantity = 1;
    var isMixedMode = false;

    function getRequiredSlots() {
      return Math.min(Math.max(1, selectedQuantity), maxSlots);
    }

    function setMixedOnlyVisibility() {
      var carouselWrap = container.querySelector('[data-bundle-variant-carousel]');
      var visible = isMixedMode && currentVariant;
      if (carouselWrap) carouselWrap.style.display = visible ? '' : 'none';
      container.classList.toggle('product-bundle-builder--single-mode', !isMixedMode);
    }
    function setVariant(v) {
      currentVariant = v;
      if (!currentVariant) {
        if (selectSizeMsg) selectSizeMsg.style.display = '';
        if (variantCarousel) variantCarousel.style.display = 'none';
        if (modeTabs) modeTabs.style.display = 'none';
        var stylePills = container.querySelector('[data-bundle-style-pills]');
        if (stylePills) stylePills.style.display = 'none';
        updateSelectionCount();
        renderSlots();
        updateProgress();
        updateAtc();
        return;
      }
      if (selectSizeMsg) selectSizeMsg.style.display = 'none';
      if (modeTabs) modeTabs.style.display = '';
      setMixedOnlyVisibility();
      updateTierBlockPrices(currentVariant.price);
      renderSlots();
      updateProgress();
      updateAtc();
      updateSelectionCount();
    }

    function updateSelectionCount() {
      var required = getRequiredSlots();
      var count = bundleItems.length;
      if (progressCount) progressCount.textContent = count + ' / ' + required;
    }
    function updateQtyDisplay() {
      if (qtyValueEl) qtyValueEl.textContent = selectedQuantity;
    }

    function addByVariant(variantObj) {
      if (!variantObj || !variantObj.available) return;
      var required = getRequiredSlots();
      if (bundleItems.length >= required) return;
      bundleItems.push(variantObj);
      renderSlots();
      updateProgress();
      updateAtc();
    }

    function renderSlots() {
      var required = getRequiredSlots();
      var count = bundleItems.length;
      slotElements.forEach(function (slot, index) {
        var variant = bundleItems[index] || null;
        var isEmpty = !variant;
        var plusWrap = slot.querySelector('.product-bundle-builder__slot-plus');
        var filledWrap = slot.querySelector('.product-bundle-builder__slot-filled');
        var img = slot.querySelector('[data-slot-img]');
        var removeBtn = slot.querySelector('[data-slot-remove]');
        var sizeSelect = slot.querySelector('[data-slot-size-select]');

        if (index >= required) {
          slot.style.display = 'none';
          return;
        }
        slot.style.display = '';

        var isAddMoreSlot = isEmpty && index === count;
        slot.classList.toggle('product-bundle-builder__slot--add-more', isAddMoreSlot);
        if (isEmpty) {
          slot.classList.add('product-bundle-builder__slot--empty');
          slot.classList.remove('product-bundle-builder__slot--filled');
          if (plusWrap) plusWrap.style.display = '';
          if (filledWrap) filledWrap.style.display = 'none';
          slot.setAttribute('aria-label', 'Add item to bundle');
        } else {
          slot.classList.remove('product-bundle-builder__slot--empty');
          slot.classList.add('product-bundle-builder__slot--filled');
          if (plusWrap) plusWrap.style.display = 'none';
          if (filledWrap) filledWrap.style.display = '';
          if (variant && img) {
            var feat = variant.featured_image;
            if (feat && feat.src) img.src = feat.src; else img.removeAttribute('src');
          }
          if (removeBtn) removeBtn.style.display = '';
          if (sizeSelect) {
            sizeSelect.style.display = '';
            if (variant) {
              var sizeVal = variant['option' + (sizeOptIndex + 1)];
              if (sizeVal != null && sizeSelect.querySelector('option[value="' + String(sizeVal).replace(/"/g, '&quot;') + '"]')) sizeSelect.value = sizeVal;
            }
          }
          slot.setAttribute('aria-label', 'Remove item from bundle');
        }
      });
    }

    function updateProgress() {
      var required = getRequiredSlots();
      var count = bundleItems.length;
      var pct = required > 0 ? Math.min(100, (count / required) * 100) : 0;
      if (progressBar) progressBar.style.width = pct + '%';
      updateSelectionCount();
    }

    function updateAtc() {
      if (!atcBtn) return;
      var required = getRequiredSlots();
      var count = bundleItems.length;
      var canAdd;
      if (isMixedMode) {
        canAdd = currentVariant && required > 0 && count === required && bundleItems.every(function (v) { return v && v.available; });
      } else {
        canAdd = currentVariant && currentVariant.available && selectedQuantity >= 1;
      }
      atcBtn.disabled = !canAdd;
    }

    function showSlotMessage(text) {
      if (!slotMessage) return;
      slotMessage.textContent = text;
      slotMessage.style.display = 'block';
      setTimeout(function () { slotMessage.style.display = 'none'; slotMessage.textContent = ''; }, 3500);
    }

    function addSlot() {
      var selectedNow = findCurrentVariant(container, sectionId);
      if (!selectedNow || !selectedNow.available) return;
      var required = getRequiredSlots();
      if (bundleItems.length >= required) return;
      bundleItems.push(selectedNow);
      if (slotMessage) { slotMessage.style.display = 'none'; slotMessage.textContent = ''; }
      renderSlots();
      updateProgress();
      updateAtc();
    }

    function removeSlot(index) {
      if (index < 0 || index >= bundleItems.length) return;
      bundleItems.splice(index, 1);
      renderSlots();
      updateProgress();
      updateAtc();
    }

    function setSlotVariant(index, variant) {
      var v = variant || findCurrentVariant(container, sectionId);
      if (!v || !v.available) return;
      if (index >= bundleItems.length) {
        bundleItems.push(v);
      } else {
        bundleItems[index] = v;
      }
      renderSlots();
      updateProgress();
      updateAtc();
    }

    document.documentElement.addEventListener('bundle:quantity-selected', function (e) {
      if (e.detail && (String(e.detail.sectionId) === String(sectionId) || e.detail.sectionId == null)) {
        selectedQuantity = Math.min(maxSlots, Math.max(1, parseInt(e.detail.qty, 10) || 1));
        bundleItems = bundleItems.slice(0, selectedQuantity);
        updateQtyDisplay();
        updateSelectionCount();
        renderSlots();
        updateProgress();
        updateAtc();
      }
    });

    document.documentElement.addEventListener('product:variant-change', function (e) {
      if (e.detail && (String(e.detail.sectionId) === String(sectionId) || e.detail.sectionId == null) && e.detail.variant) {
        setVariant(e.detail.variant);
      }
    });

    var checkVariant = function () {
      var v = findCurrentVariant(container, sectionId);
      setVariant(v);
    };

    checkVariant();
    setTimeout(checkVariant, 50);
    setTimeout(checkVariant, 300);
    setMixedOnlyVisibility();

    function getSizeOptionIndex() {
      for (var o = 0; o < options.length; o++) {
        if (options[o].name && options[o].name.toLowerCase() === 'size') return o;
      }
      return 0;
    }

    function filterCarouselBySize(sizeVal) {
      if (!variantCarousel || !sizeVal) return;
      var optKey = 'data-variant-option' + (sizeOptIndex + 1);
      variantCarousel.querySelectorAll('[data-variant-id]').forEach(function (card) {
        card.style.display = card.getAttribute(optKey) === sizeVal ? '' : 'none';
      });
    }

    function applySizeAndSetVariant(sizeVal) {
      if (!variants || !variants.length || !sizeVal) return;
      var styleVal = selectedStyleValue;
      var v = null;
      if (options.length > 1 && styleVal != null) {
        v = variants.find(function (x) {
          if (!x.available) return false;
          var sizeKey = 'option' + (sizeOptIndex + 1);
          var styleKey = 'option' + (styleOptIndex + 1);
          return String(x[sizeKey]) === String(sizeVal) && String(x[styleKey]) === String(styleVal);
        });
      }
      if (!v) v = variants.find(function (x) { return String(x['option' + (sizeOptIndex + 1)]) === String(sizeVal) && x.available; });
      if (v) {
        setVariant(v);
        filterCarouselBySize(sizeVal);
        var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (idInput) idInput.value = v.id;
        if (typeof window.dispatchCustomEvent === 'function') {
          document.documentElement.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v, sectionId: sectionId } }));
        }
      } else {
        setVariant(null);
        if (variantCarousel) variantCarousel.querySelectorAll('[data-variant-id]').forEach(function (card) { card.style.display = ''; });
      }
    }

    if (sizeButtons.length) {
      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeButtons.forEach(function (b) { b.classList.remove('selected'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('selected');
          btn.setAttribute('aria-pressed', 'true');
          var sizeVal = btn.getAttribute('data-size-value');
          applySizeAndSetVariant(sizeVal);
        });
      });
    }
    if (modeTabs) {
      var modeButtons = modeTabs.querySelectorAll('.product-bundle-builder__mode-tab');
      modeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-mode') || 'single';
          isMixedMode = mode === 'mixed';
          modeButtons.forEach(function (b) {
            var isActive = b === btn;
            b.classList.toggle('active', isActive);
            b.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          setMixedOnlyVisibility();
          renderSlots();
          updateProgress();
          updateAtc();
        });
      });
    }

    if (styleDropdown) {
      styleDropdown.addEventListener('change', function () {
        selectedStyleValue = styleDropdown.value || null;
        var activeSize = container.querySelector('[data-size-value].selected');
        if (activeSize) applySizeAndSetVariant(activeSize.getAttribute('data-size-value'));
      });
    }
    var stylePillBtns = container.querySelectorAll('[data-style-value]');
    stylePillBtns.forEach(function (pill) {
      pill.addEventListener('click', function () {
        selectedStyleValue = pill.getAttribute('data-style-value');
        var activeSize = container.querySelector('[data-size-value].selected');
        if (activeSize) applySizeAndSetVariant(activeSize.getAttribute('data-size-value'));
      });
    });

    if (variantCarousel) {
      var carouselInner = container.querySelector('[data-bundle-variant-carousel-inner]');
      variantCarousel.querySelectorAll('[data-variant-id]').forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.disabled) return;
          var vid = card.getAttribute('data-variant-id');
          var v = variants && variants.find(function (x) { return String(x.id) === String(vid); });
          if (v) addByVariant(v);
        });
      });
      container.querySelectorAll('[data-carousel-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!carouselInner) return;
          var dir = btn.getAttribute('data-carousel-nav') === 'prev' ? -1 : 1;
          carouselInner.scrollBy({ left: dir * 120, behavior: 'smooth' });
        });
      });
    }

    var slotsTrack = container.querySelector('[data-bundle-slots]');
    if (slotsTrack) {
      container.querySelectorAll('[data-slots-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-slots-nav') === 'prev' ? -1 : 1;
          var step = 92;
          slotsTrack.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
    }

    var findMyFitBtn = container.querySelector('[data-find-my-fit]');
    if (findMyFitBtn) {
      findMyFitBtn.addEventListener('click', function () {
        var sizeGuideModal = document.getElementById('sizeGuideModal');
        if (sizeGuideModal) {
          sizeGuideModal.style.display = 'flex';
          return;
        }
        var popup = document.querySelector('.product-popup-modal__button[aria-haspopup="dialog"]');
        if (popup) popup.click();
        else {
          var vs = document.querySelector('#variant-selects-' + sectionId);
          if (vs) {
            var fieldset = vs.querySelector('fieldset');
            if (fieldset) { var input = fieldset.querySelector('select, input[type="radio"]'); if (input) input.focus(); }
          }
        }
      });
    }
    if (focusSizeBtn) {
      focusSizeBtn.addEventListener('click', function () {
        var vs = document.querySelector('#variant-selects-' + sectionId);
        if (vs) {
          var fieldset = vs.querySelector('fieldset');
          if (fieldset) {
            var input = fieldset.querySelector('select, input[type="radio"]');
            if (input) { input.focus(); if (input.tagName === 'SELECT') input.click(); }
          }
        }
      });
    }

    if (modeTabs) {
      modeTabs.querySelectorAll('[data-mode]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          modeTabs.querySelectorAll('[data-mode]').forEach(function (t) {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');
          isMixedMode = tab.getAttribute('data-mode') === 'mixed';
          setMixedOnlyVisibility();
          renderSlots();
        });
      });
    }

    slotElements.forEach(function (slot, index) {
      slot.addEventListener('click', function (e) {
        if (e.target.closest('[data-slot-remove]') || e.target.closest('[data-slot-size-select]')) return;
        if (bundleItems[index]) {
          setSlotVariant(index);
          return;
        }
        if (bundleItems.length < getRequiredSlots()) {
          var carouselVisible = variantCarousel && variantCarousel.style.display !== 'none';
          if (carouselVisible) variantCarousel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          else addSlot();
        }
      });
      var removeBtn = slot.querySelector('[data-slot-remove]');
      if (removeBtn) {
        removeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          removeSlot(index);
        });
      }
      var sizeSelect = slot.querySelector('[data-slot-size-select]');
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function (e) {
          e.stopPropagation();
          var val = sizeSelect.value;
          if (!val || !variants || !options.length) return;
          var optionIndex = 0;
          for (var o = 0; o < options.length; o++) {
            if (options[o].name && options[o].name.toLowerCase() === 'size') {
              optionIndex = o;
              break;
            }
          }
          var optKey = 'option' + (optionIndex + 1);
          var currentSlotV = bundleItems[index];
          var v;
          if (currentSlotV) {
            v = variants.find(function (x) {
              if (!x.available) return false;
              if (String(x[optKey]) !== String(val)) return false;
              for (var k = 1; k <= 3; k++) {
                var key = 'option' + k;
                if (k !== optionIndex + 1 && currentSlotV[key] != null && x[key] !== currentSlotV[key]) return false;
              }
              return true;
            });
          } else {
            v = variants.find(function (x) { return String(x[optKey]) === String(val) && x.available; });
          }
          if (v) setSlotVariant(index, v);
        });
      }
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled || atcBtn.classList.contains('loading')) return;
        var required = getRequiredSlots();
        if (isMixedMode && (bundleItems.length !== required)) return;
        if (!isMixedMode && (!currentVariant || !currentVariant.available || selectedQuantity < 1)) return;

        atcBtn.classList.add('loading');
        atcBtn.setAttribute('aria-disabled', 'true');
        var textEl = atcBtn.querySelector('[data-atc-text]');
        var loadingEl = atcBtn.querySelector('.product-bundle-builder__atc-loading');
        if (textEl) textEl.style.display = 'none';
        if (loadingEl) loadingEl.style.display = '';

        var cartAddUrl = typeof theme !== 'undefined' && theme.routes ? theme.routes.cart_add_url : '/cart/add';
        var sectionsParam = getSectionsToRender().map(function (s) { return s.section; }).join(',');
        var sectionsUrl = window.location.pathname;
        var isLast = function (idx) { return idx === bundleItems.length - 1; };

        function addOneToCart(variantId, idx) {
          var formData = new FormData();
          formData.append('id', String(variantId));
          formData.append('quantity', 1);
          formData.append('properties[_bundle_slot]', String(idx + 1));
          if (isLast(idx)) {
            formData.append('sections', sectionsParam);
            formData.append('sections_url', sectionsUrl);
          }
          return fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            body: formData
          }).then(function (res) { return res.json(); });
        }

        function addSingleToCart() {
          var formData = new FormData();
          formData.append('id', String(currentVariant.id));
          formData.append('quantity', String(selectedQuantity));
          formData.append('sections', sectionsParam);
          formData.append('sections_url', sectionsUrl);
          return fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            body: formData
          }).then(function (res) { return res.json(); });
        }

        var chain;
        if (!isMixedMode) {
          chain = addSingleToCart();
        } else {
          var variantIds = bundleItems.map(function (item) { return item.id; });
          chain = Promise.resolve(null);
          for (var i = 0; i < variantIds.length; i++) {
            (function (vid, idx) {
              chain = chain.then(function (data) {
                if (data != null && data.status != null && data.status !== 200) return Promise.reject(data);
                return addOneToCart(vid, idx);
              });
            })(variantIds[i], i);
          }
        }
        chain
          .then(function (data) {
            if (data && data.status && data.status !== 200) {
              if (data.description) alert(data.description);
              return;
            }
            if (data && data.sections) renderCartContents(data);
            if (typeof window.dispatchCustomEvent === 'function') {
              window.dispatchCustomEvent('cart:item-added', { product: data && data.items && data.items[0] ? data.items[0] : data });
            }
          })
          .catch(function (err) {
            if (err && err.description) alert(err.description);
            else if (err) console.error(err);
          })
          .finally(function () {
            atcBtn.classList.remove('loading');
            atcBtn.removeAttribute('aria-disabled');
            if (textEl) textEl.style.display = '';
            if (loadingEl) loadingEl.style.display = 'none';
          });
      });
    }

    var initialVariant = findCurrentVariant(container, sectionId);
    if (initialVariant && sizeButtons.length) {
      var initialSize = initialVariant['option' + (sizeOptIndex + 1)];
      if (initialSize) {
        sizeButtons.forEach(function (btn) {
          if (btn.getAttribute('data-size-value') === initialSize) {
            btn.classList.add('selected');
            btn.setAttribute('aria-pressed', 'true');
          }
        });
        if (variantCarousel) filterCarouselBySize(initialSize);
      }
      if (options.length > 1) selectedStyleValue = initialVariant['option' + (styleOptIndex + 1)];
    }
    setVariant(initialVariant);
    updateSelectionCount();
    updateQtyDisplay();

    var quantityBlocks = document.querySelectorAll('[data-bundle-quantity-blocks] [data-quantity-block]');
    var blockQuantities = [];
    quantityBlocks.forEach(function (b) {
      var q = parseInt(b.getAttribute('data-qty'), 10);
      if (!isNaN(q)) blockQuantities.push(q);
    });
    blockQuantities.sort(function (a, b) { return a - b; });
    var maxQty = blockQuantities.length ? blockQuantities[blockQuantities.length - 1] : 15;

    function getBlockQtyForHighlight(qty) {
      if (qty >= (blockQuantities[3] || 15)) return blockQuantities[3] || 15;
      if (qty >= (blockQuantities[2] || 7)) return blockQuantities[2] || 7;
      if (qty >= (blockQuantities[1] || 4)) return blockQuantities[1] || 4;
      return blockQuantities[0] || 1;
    }
    function syncBlocksHighlight() {
      var highlightQty = getBlockQtyForHighlight(selectedQuantity);
      quantityBlocks.forEach(function (b) {
        var bq = parseInt(b.getAttribute('data-qty'), 10);
        if (bq === highlightQty) {
          b.classList.add('selected');
          b.setAttribute('aria-pressed', 'true');
        } else {
          b.classList.remove('selected');
          b.setAttribute('aria-pressed', 'false');
        }
      });
    }

    if (qtyMinusBtn) {
      qtyMinusBtn.addEventListener('click', function () {
        if (selectedQuantity <= 1) return;
        selectedQuantity = selectedQuantity - 1;
        syncBlocksHighlight();
        updateQtyDisplay();
        document.documentElement.dispatchEvent(new CustomEvent('bundle:quantity-selected', { detail: { qty: selectedQuantity, sectionId: sectionId } }));
      });
    }
    if (qtyPlusBtn) {
      qtyPlusBtn.addEventListener('click', function () {
        if (selectedQuantity >= maxQty) return;
        selectedQuantity = selectedQuantity + 1;
        syncBlocksHighlight();
        updateQtyDisplay();
        document.documentElement.dispatchEvent(new CustomEvent('bundle:quantity-selected', { detail: { qty: selectedQuantity, sectionId: sectionId } }));
      });
    }
    syncBlocksHighlight();
  }

  document.documentElement.addEventListener('product:variant-change', function (e) {
    if (e.detail && e.detail.variant && e.detail.variant.price != null) {
      updateTierBlockPrices(e.detail.variant.price);
    }
  });

  function setBundleTabActive(active) {
    var tabs = document.querySelector('.product-info-tabs[data-product-tabs]');
    if (!tabs) return;
    tabs.setAttribute('data-active', active);
    var singleBtn = document.getElementById('product-tab-single-btn');
    var bundleBtn = document.getElementById('product-tab-bundle-btn');
    if (singleBtn) { singleBtn.classList.toggle('active', active === 'single'); singleBtn.setAttribute('aria-selected', active === 'single'); }
    if (bundleBtn) { bundleBtn.classList.toggle('active', active === 'bundle'); bundleBtn.setAttribute('aria-selected', active === 'bundle'); }
    if (active === 'bundle' && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search + '#bundle');
    }
  }

  function scrollToBundleAndOpenTab() {
    setBundleTabActive('bundle');
  }

  document.documentElement.addEventListener('click', function (e) {
    var tabBtn = e.target.closest('.product-info-tabs__btn[data-tab]');
    if (!tabBtn || !tabBtn.closest('.product-info-tabs')) return;
    e.preventDefault();
    e.stopPropagation();
    var tab = tabBtn.getAttribute('data-tab');
    if (tab) setBundleTabActive(tab);
    if (tab === 'bundle' && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search + '#bundle');
    }
  });

  function init() {
    initQuantityBlocks();
    var containers = document.querySelectorAll('.product-bundle-builder[data-section-id]');
    if (containers.length) containers.forEach(initBundleBuilder);
    if (window.location.hash === '#bundle') setTimeout(scrollToBundleAndOpenTab, 100);
  }

  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#bundle') scrollToBundleAndOpenTab();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
